/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

/**
 * The Card component
 *
 * @author Thais Watanabe
 */
const Card = (props) => {
  return (
    <div className={`${props.className} bg-white rounded-lg shadow p-1 mb-5 print:shadow-none print:m-0 print:p-0`}>
      {props.title != null && (
        <div className="px-4 py-5 sm:px-6 print:hidden">
          <h3 className="text-lg leading-6 font-medium text-gray-900 print:bg-gray-50">
            {props.title} {props.edit && props.edit}
          </h3>
        </div>
      )}
      {props.children}
    </div>
  );
};

export default Card;
